class ScrollToHelper {
    static scrollTo(element = null, additionalSpacing = ScrollToHelper.getHeaderHeight()) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        let top = element !== null ? element.getBoundingClientRect().top + scrollTop : 0;

        if (additionalSpacing !== 0) {
            top -= additionalSpacing;
        }

        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top,
        });
    }

    static getElementTopOffset(element = null) {
        let scrollTop = window.pageYOffset;

        if (window.pageYOffset === undefined) {
            [scrollTop] = (document.documentElement || document.body.parentNode || document.body);
        }

        return element !== null ? element.getBoundingClientRect().top + scrollTop : 0;
    }

    static getHeaderHeight() {
        return document.querySelector('.page-header').getBoundingClientRect().height;
    }

    static initializeAnchorLinks(lazysizes) {
        const links = document.querySelectorAll('a[href^="#"]');
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();

                const href = event.currentTarget.getAttribute('href');

                if (href.length <= 1 || !href.match('^#')) {
                    return;
                }

                const targetId = href.replace(/^#/, '');
                const targetElement = document.getElementById(targetId);

                const imagesToLoad = ScrollToHelper.getAllImagesBetweenCurrentAndTarget(
                    event.currentTarget, targetElement,
                );

                imagesToLoad.forEach((image) => {
                    lazysizes.loader.unveil(image);
                });

                window.requestAnimationFrame(() => {
                    ScrollToHelper.scrollTo(targetElement);
                });
            });
        });
    }

    static getAllImagesBetweenCurrentAndTarget(currentElement, targetElement) {
        let eventContainer = currentElement.closest('.component-container');
        const targetContainer = targetElement.closest('.component-container');
        const containersToCross = [];

        while (eventContainer) {
            if (eventContainer && eventContainer !== targetContainer) {
                containersToCross.push(eventContainer);
            }
            eventContainer = eventContainer.nextElementSibling;

            if (!eventContainer || eventContainer === targetContainer) {
                break;
            }
        }

        const images = containersToCross.map((container) => {
            return ([...container.querySelectorAll('.lazyload')]);
        });

        return images.flat();
    }
}

export default ScrollToHelper;
